/** 同一帧内合并 mapRegion / dealers 多次变更，避免 Tab 切换重复渲染 */
export function createMapRegionRefreshScheduler(runRefresh) {
  let rafId = 0;
  return () => {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      rafId = 0;
      runRefresh();
    });
  };
}
